// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1aYur","row":"styles_row__24jp9"};